import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./App.css";
import "./style/Login.css";
import "./style/OrganizerDashboard.css";
import "./style/Signup.css";
import "./style/UserDashboard.css";
import "./style/Error.css";
import "./style/Event.css";
import "./style/Loader.css";
import "./style/CreateEventModal.css";
import "./style/Navbar.css";
import "./style/About.css";
import "./style/Hero.css";
import "./style/PopularEvents.css";
import "./style/HomeStats.css";
import "./style/Footer.css";
import "./style/Contact.css";
import './style/Buttons.css';

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
